module.exports = __webpack_public_path__ + "static/sunken-forest-walk.64345f09.png";